<template viewBox="0 0 22.001 18">
  <g transform="translate(0 0)">
    <path
          d="M19,18H1a1,1,0,0,1-1-1V6a1,1,0,0,1,1.53-.848L8.983,9.81l5.462-3.641a1,1,0,1,1,1.11,1.664l-6,4a1,1,0,0,1-1.085.016L2,7.8V16H18V5.83A2.992,2.992,0,0,1,16.17,4H3A1,1,0,0,1,3,2H16.17A3,3,0,1,1,20,5.83V17A1,1,0,0,1,19,18ZM19,2a1,1,0,1,0,1,1A1,1,0,0,0,19,2Z"
          transform="translate(0 0)" fill="#0d5740"/>
  </g>
</template>

<script>
  export default {
    name: "mailTo"
  }
</script>

<style scoped>

</style>
